var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { observer } from "mobx-react";
import React from 'react';
import { StoreContext } from "@/app/uistore/Rootstore";
import { Box, Flex, Text, Icon } from "@chakra-ui/react";
import { FaChevronLeft } from "@react-icons/all-files/fa/FaChevronLeft";
import { FaChevronRight } from "@react-icons/all-files/fa/FaChevronRight";
import { BsMicFill } from "@react-icons/all-files/bs/BsMicFill";
import { BsMicMuteFill } from "@react-icons/all-files/bs/BsMicMuteFill";
import { BiPin } from "@react-icons/all-files/bi/BiPin";
import { GiPin } from "@react-icons/all-files/gi/GiPin";
import { ScaleLoader } from "react-spinners";
let Footer = class Footer extends React.Component {
    moveForward() {
        const rstore = this.context;
        rstore.mediastore.moveForward();
    }
    moveBackward() {
        const rstore = this.context;
        rstore.mediastore.moveBackward();
    }
    render() {
        const rstore = this.context;
        const item = rstore.mediastore.getPageItems(rstore.mediastore.activefooterpagenumber);
        return React.createElement(Flex, null,
            React.createElement(Box, { h: '100%', w: '30px' }, rstore.mediastore.activefooterpagenumber > 1 &&
                React.createElement(Icon, { _hover: { cursor: 'pointer' }, onClick: () => this.moveBackward(), w: '30px', h: '130px', as: FaChevronLeft, color: 'lightgray' })),
            item.map((it) => React.createElement(MediaFooter, { key: it.id, mediaobject: it })),
            React.createElement(Box, { h: '100%', w: '30px' }, rstore.mediastore.totalpages > 1 &&
                rstore.mediastore.activefooterpagenumber <= rstore.mediastore.totalpages
                &&
                    React.createElement(Icon, { onClick: () => this.moveForward(), _hover: { cursor: 'pointer' }, w: '30px', h: '130px', as: FaChevronRight, color: 'lightgray' })));
    }
};
Footer.contextType = StoreContext;
Footer = __decorate([
    observer
], Footer);
export { Footer };
let MediaFooter = class MediaFooter extends React.Component {
    constructor(props) {
        super(props);
    }
    async startmedia() {
        if (this.props.mediaobject.videoref !== null &&
            this.props.mediaobject.videoref.current !== null &&
            this.props.mediaobject.mediastream !== undefined &&
            this.props.mediaobject.videoref.current.srcObject === null) {
            this.props.mediaobject.videoref.current.srcObject = this.props.mediaobject.mediastream;
            try {
                await this.props.mediaobject.videoref.current.play();
            }
            catch (ex) {
            }
        }
    }
    componentDidMount() {
        setTimeout(() => {
            this.startmedia();
        }, 1000);
    }
    componentDidUpdate() {
        setTimeout(() => {
            this.startmedia();
        }, 1000);
    }
    pinPeer() {
        const rstore = this.context;
        if (rstore.mediastore.pinnedpeer === this.props.mediaobject.id) {
            rstore.mediastore.unpinPeer();
        }
        else {
            rstore.mediastore.pinPeer(this.props.mediaobject.id);
        }
    }
    render() {
        const rstore = this.context;
        const it = this.props.mediaobject;
        const isvideo = this.props.mediaobject.mediastream !== undefined &&
            this.props.mediaobject.mediastream.getVideoTracks().length > 0;
        return React.createElement(Box, { onClick: () => rstore.mediastore.presentPeer(this.props.mediaobject.id), _hover: { cursor: 'pointer' }, w: rstore.mediastore.itemwidth, ml: '10px' },
            React.createElement(Box, { position: 'relative', borderWidth: '1px', borderColor: 'lightgray', key: it.id, w: rstore.mediastore.itemwidth },
                !it.addingpeer && rstore.mediastore.sharingpeerid.has(this.props.mediaobject.id) &&
                    React.createElement("video", { style: {
                            pointerEvents: 'none', height: '120px',
                            width: rstore.mediastore.itemwidth + "px",
                            objectFit: 'contain'
                        }, className: this.props.mediaobject.mediacssclass, ref: this.props.mediaobject.videoref, height: '120px', width: rstore.mediastore.itemwidth + "px" }),
                !it.addingpeer &&
                    !rstore.mediastore.sharingpeerid.has(this.props.mediaobject.id) &&
                    React.createElement("video", { style: { pointerEvents: 'none',
                            height: '120px',
                            width: rstore.mediastore.itemwidth + "px",
                            objectFit: 'contain' }, className: this.props.mediaobject.mediacssclass, ref: this.props.mediaobject.videoref, height: '120px', width: rstore.mediastore.itemwidth + "px" }),
                it.addingpeer && React.createElement(Flex, { height: '120px', width: rstore.mediastore.itemwidth + "px", justify: 'center', alignItems: 'center' },
                    React.createElement(ScaleLoader, { color: 'lightgray' })),
                React.createElement(Icon, { position: 'absolute', bottom: '2px', right: '4px', width: '30px', height: '30px', color: 'lightgray', as: it.hasaudio ? BsMicFill : BsMicMuteFill }),
                React.createElement(Icon, { onClick: (e) => {
                        e.stopPropagation();
                        this.pinPeer();
                    }, position: 'absolute', top: '2px', right: '4px', color: rstore.mediastore.pinnedpeer === this.props.mediaobject.id
                        ? 'red' : 'green', width: '30px', height: '30px', as: rstore.mediastore.pinnedpeer === this.props.mediaobject.id
                        ? BiPin : GiPin })),
            React.createElement(Flex, { w: '100%', align: 'center', justify: 'center' },
                React.createElement(Text, { fontWeight: 'bold', color: 'lightgray' }, it.username)));
    }
};
MediaFooter.contextType = StoreContext;
MediaFooter = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], MediaFooter);
